import { render, staticRenderFns } from "./ActionsButtons.vue?vue&type=template&id=fc247052"
import script from "./ActionsButtons.vue?vue&type=script&lang=js"
export * from "./ActionsButtons.vue?vue&type=script&lang=js"
import style0 from "./ActionsButtons.vue?vue&type=style&index=0&id=fc247052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports